import { PaginatedAsyncComboBox } from '../../cdl/ComboBox/ComboBox';
import type { PaginatedAsyncComboBoxProps } from '../../cdl/ComboBox/ComboBox';
import { getOfferById, getOffers } from '../../common/api/clients/gateway.api';
import { queries } from '../../common/api/queryKeys/queries';
import type { OfferModel } from '../../offer/model/OfferModel';

import { IntegrationOfferDoubleLineOption } from './IntegrationOfferDoubleLineOption';

export interface IntegrationOfferSelectOption {
    label: string;
    value: string;
    offer: OfferModel;
}

interface IntegrationOfferSelectProps
    extends Omit<
        PaginatedAsyncComboBoxProps<IntegrationOfferSelectOption>,
        'onChange' | 'value' | 'optionsQueryKey' | 'optionsQueryFn' | 'selectedOptionQueryKey' | 'selectedOptionQueryFn'
    > {
    value: string;
    onChange: (option: IntegrationOfferSelectOption) => void;
}

export function IntegrationOfferSelect({ value, onChange, ...props }: IntegrationOfferSelectProps) {
    const loadOffersBySearchQuery = async (searchQuery: string, page: number) => {
        const offersPage = await getOffers({ searchQuery, page });

        return {
            ...offersPage,
            content: offersPage.content.map((offer) => ({
                label: offer.buyerReference || offer.offerNumber,
                value: offer.id,
                offer,
            })),
        };
    };

    const loadOfferById = async (offerId: string): Promise<IntegrationOfferSelectOption> => {
        const offer = await getOfferById(offerId);
        return {
            label: offer.buyerReference || offer.offerNumber,
            value: offer.id,
            offer,
        };
    };

    return (
        <PaginatedAsyncComboBox<IntegrationOfferSelectOption>
            {...props}
            value={value || null}
            onChange={(_, meta) => {
                if (meta.option) {
                    onChange(meta.option);
                }
            }}
            optionsQueryKey={(search) => queries.offers.comboBoxOptions(search).queryKey}
            optionsQueryFn={({ search, page }) => loadOffersBySearchQuery(search, page)}
            selectedOptionQueryKey={(id) => queries.offers.selectedComboBoxOption(id).queryKey}
            selectedOptionQueryFn={loadOfferById}
            OptionComponent={IntegrationOfferDoubleLineOption}
        />
    );
}
